// components/LoadingScreen.js
import React, { useState, useEffect } from 'react';
import './LoadingScreen.scss';

const initialFacts = [
  "Data privacy is a basic human right.",
  "Cookies can track your online behavior.",
  "It takes 18 minutes to read an average privacy policy.",
  "Only 9% of adults read privacy policies before agreeing.",
  "California's CCPA grants consumers data collection rights.",
  "The right to be forgotten allows deletion of personal data.",
  "Websites may collect data without user sign-ups or purchases.",
  "Privacy policies can change; it's important to review them.",
  "Transparent, user-friendly privacy policies are on the rise.",
  "Data breaches risk personal info; understand privacy practices.",
  "Different US states have varying privacy laws.",
  "Privacy by design embeds data protection into products.",
  "The General Data Protection Regulation (GDPR) is a major shift in data privacy law in Europe.",
  "Incognito mode doesn't make your browsing activity private to websites you visit or your internet service provider.",
  "Third-party tracking cookies are increasingly being blocked by default in popular web browsers.",
  "De-identified data can sometimes be re-identified with enough pieces of seemingly innocuous information.",
  "Many apps collect more data than necessary for their functionality.",
  "Internet of Things (IoT) devices often collect and transmit data without clear privacy policies.",
  "Your digital footprint includes everything you do online, from comments and likes to purchases.",
  "Many free online services monetize through targeted ads based on user data.",
  "Children's Online Privacy Protection Act (COPPA) protects children's privacy online.",
  "Personalized advertisements are often based on your browsing history and online behavior.",
  "Biometric data like fingerprints and facial recognition are unique identifiers and highly sensitive.",
  "Data brokers collect and sell personal information, often without explicit consent.",
  "Public Wi-Fi networks can be risky due to potential snooping on unencrypted data transmissions.",
  "Most social media platforms track your behavior, even when you're not on their site.",
  "Health data privacy is crucial, but not all health apps are subject to HIPAA regulations.",
  "Data anonymization techniques aim to protect privacy but are not always infallible.",
  "AI and machine learning can pose new challenges for data privacy due to the large volumes of data they use.",
  "Blockchain technology has potential for enhanced data privacy, but it's not a panacea.",
  "Two-factor authentication adds an extra layer of security, but isn't a guarantee of privacy."
];

const LoadingScreen = () => {
  const [dots, setDots] = useState('');
  const [factIndex, setFactIndex] = useState(0);
  const [facts, setFacts] = useState([]);

  useEffect(() => {
    setFacts([...initialFacts].sort(() => Math.random() - 0.5)); // Shuffle the facts on load
  }, []);

  useEffect(() => {
    const dotsInterval = setInterval(() => {
      setDots((prevDots) => (prevDots.length < 3 ? prevDots + '.' : ''));
    }, 500);

    const factsInterval = setInterval(() => {
      setFactIndex((prevIndex) => (prevIndex + 1) % facts.length);
    }, 4000);

    return () => {
      clearInterval(dotsInterval);
      clearInterval(factsInterval);
    };
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facts]);

  return (
      <div className="LoadingScreen message PrivacyGPT">
        <div>
          Thinking{dots}
        </div>
        <div className="Fact">
          {facts[factIndex]}
        </div>
      </div>
  );
};

export default LoadingScreen;
